// Isotope
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
// make Isotope a jQuery plugin
jQueryBridget( 'isotope', Isotope, $ );

// filter functions
var filterFns = {
  // show if number is greater than 50
  numberGreaterThan50: function() {
    var number = $(this).find('.number').text();
    return parseInt( number, 10 ) > 50;
  },
  // show if name ends with -ium
  ium: function() {
    var name = $(this).find('.name').text();
    return name.match( /ium$/ );
  }
};

export function getHashFilter() {
  // get filter=filterName
  var matches = location.hash.match( /filter=([^&]+)/i );
  var hashFilter = matches && matches[1];
  return hashFilter && decodeURIComponent( hashFilter );
}

// init Isotope
//var $grid = $('.c-jobs-index-list').isotope({
//  itemSelector: '.c-jobs-index-item',
//  layoutMode: 'vertical'
//});
var $grid = $('.c-jobs-index-list');

// store filter for each group
var filters = {};

$('.js-filters').on( 'click', '[role="option"]', function( event ) {
  var $this = $(this);
  // get group key
  var $buttonGroup = $this.parents('.c-listbox-list');
  var filterGroup = $buttonGroup.attr('data-filter-group');
  // set filter for group
  filters[ filterGroup ] = $this.attr('data-filter');
  // combine filters
  var filterValue = concatValues( filters );
  //console.log(filters[ filterGroup ]);
  // arrange, and use filter fn
  $grid.isotope({ filter: filterValue });
  // set filter in hash
  location.hash = 'filter=' + encodeURIComponent( filterValue );
});

// flatten object by concatting values
function concatValues( obj ) {
  var value = '';
  for ( var prop in obj ) {
    value += obj[ prop ];
  }
  return value;
}

var isIsotopeInit = false;
let hasFilterData = {};

function onHashchange() {
  var hashFilter = getHashFilter();
  if ( !hashFilter && isIsotopeInit ) {
    return;
  }
  //console.log(hashFilter);
  isIsotopeInit = true;
  // filter isotope
  $grid.isotope({
    itemSelector: '.c-jobs-index-item',
    layoutMode: 'vertical',
    // use filterFns
    filter: filterFns[ hashFilter ] || hashFilter,
  });

  //$grid.isotope( 'on', 'arrangeComplete', function() {
  //  console.log('arrange is complete');
  //});
  
  // set selected class on button
  if ( hashFilter ) {
    //console.log(hashFilter);
    //console.log(catJobsFunctionDescrData.betreuungskraft);
    //$filterButtonGroup.find('.is-checked').removeClass('is-checked');
    //$filterButtonGroup.find('[data-filter="' + hashFilter + '"]').addClass('is-checked');
    
    // Funktion
    // hash has filter »Funktion«?
    for (var prop in catJobsFunctionDescrData) {
      var propClassName = '.' + prop;

      $('[data-filter-group="jfunc"]')
        .find('[role="option"]')
        .removeClass('focused')
        .removeAttr('aria-selected');
      
      if (hashFilter.indexOf(propClassName) !== -1) {
        hasFilterData.func = prop;
        console.log(prop);

        $('[data-filter-group="jfunc"]')
          .find('[data-filter=".' + prop + '"]')// beware of the period
          .addClass('focused')
          .attr('aria-selected', 'true');
        
        break;
      }
    };
    
    // Ort
    // hash has filter »Ort«?
    for (var prop in catJobsPlaceDescrData) {
      var propClassName = '.' + prop;

      $('[data-filter-group="jplace"]')
        .find('[role="option"]')
        .removeClass('focused')
        .removeAttr('aria-selected');
      
      if (hashFilter.indexOf(propClassName) !== -1) {
        hasFilterData.place = prop;
        console.log(prop);

        $('[data-filter-group="jplace"]')
          .find('[data-filter=".' + prop + '"]')// beware of the period
          .addClass('focused')
          .attr('aria-selected', 'true');
        
        break;
      }
    };
    
    // Zeitpunkt
    // hash has filter »Zeit«?
    /*for (var prop in catJobsDateDescrData) {
      var propClassName = '.' + prop;

      $('[data-filter-group="jdate"]')
        .find('[role="option"]')
        .removeClass('focused')
        .removeAttr('aria-selected');
      
      if (hashFilter.indexOf(propClassName) !== -1) {
        hasFilterData.date = prop;
        console.log(prop);

        $('[data-filter-group="jdate"]')
          .find('[data-filter=".' + prop + '"]')// beware of the period
          .addClass('focused')
          .attr('aria-selected', 'true');
        
        break;
      }
    };*/
    
    // Typ
    // hash has filter »Type«?
    for (var prop in catJobsTypeDescrData) {
      var propClassName = '.' + prop;

      $('[data-filter-group="jtype"]')
        .find('[role="option"]')
        .removeClass('focused')
        .removeAttr('aria-selected');
      
      if (hashFilter.indexOf(propClassName) !== -1) {
        hasFilterData.type = prop;
        console.log(prop);

        $('[data-filter-group="jtype"]')
          .find('[data-filter=".' + prop + '"]')// beware of the period
          .addClass('focused')
          .attr('aria-selected', 'true');
        
        break;
      }
    };
  }
}

export { hasFilterData };

$(window).on( 'hashchange', onHashchange );

// trigger event handler to init Isotope
onHashchange();